import type { Session } from '@supabase/supabase-js';

type FetchOptions = Omit<RequestInit, 'headers'> & {
  session?: Session | null;
  headers?: HeadersInit;
};

export async function apiFetch<T = unknown>(input: string, options: FetchOptions = {}): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set('Content-Type', 'application/json');

  if (options.session?.access_token) {
    headers.set('Authorization', `Bearer ${options.session.access_token}`);
  }

  const response = await fetch(input, {
    ...options,
    headers,
  });

  const data = (await response.json().catch(() => ({}))) as T & { error?: string };
  if (!response.ok) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[apiFetch] request failed', {
        input,
        method: options.method ?? 'GET',
        status: response.status,
        payload: data,
      });
    }
    throw new Error((data as { error?: string }).error ?? `Request failed (${response.status})`);
  }

  if (process.env.NODE_ENV !== 'production') {
    console.info('[apiFetch] request succeeded', {
      input,
      method: options.method ?? 'GET',
      status: response.status,
    });
  }

  return data;
}
